import { type AppState } from '../stores';

export const getCtaDrawer = (state: AppState) => state?.cta?.drawer;
